import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const selectedViewStorage = createJSONStorage<string | null>(
  () => localStorage,
);

export const selectedViewAtom = atomWithStorage(
  'jotai-videa-ai-view',
  null,
  selectedViewStorage,
);